import React from 'react';
import {
    Select,
    TextField,
    Stack
} from '@shopify/polaris';
import { SelectFilterTypes } from '../common/Helpers';

const operatorOptions = [
    { label: 'is equal to', value: 'EqualTo' },
    { label: 'is not equal to', value: 'NotEqualTo' },
    { label: 'contains', value: 'Contains' },
    { label: 'does not contain', value: 'DoesNotContain' },
    { label: 'starts with', value: 'StartsWith' },
    { label: 'does not start with', value: 'DoesNotStartWith' },
    { label: 'ends with', value: 'EndsWith' },
    { label: 'does not end with', value: 'DoesNotEndWith' },
];

class ProductVariantTitleFilterComponent extends React.Component {
    state = {};

    render() {

        return (
            <Stack alignment="center" spacing="tight">
                <Select
                    options={SelectFilterTypes}
                    value={this.props.filter.filterType}
                    onChange={(selected) => this.onFilterTypeChange(selected)}
                />
                <Select
                    options={operatorOptions}
                    value={this.props.filter.operator}
                    onChange={(selected) => this.onOperatorChange(selected)}
                />
                <TextField
                    placeholder="Value"
                    type="string"
                    value={this.props.filter.value.toString()}
                    onChange={(newValue) => this.onValueChange(newValue)}
                />
            </Stack>
        );
    }

    onFilterTypeChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.filterType = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onOperatorChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.operator = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onValueChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.value = newValue;

        this.props.onFilterUpdated(newFilter);
    }
}

export default ProductVariantTitleFilterComponent;
